const BASE_URL = process.env.REACT_APP_BASE_URL

const getToken = (): string => {
    const token = localStorage.getItem("access_token");
    if (!token) {
        throw new Error("Missing access token");
    }
    return token
}

export const fetchProtectedResource = async () => {
    const token = localStorage.getItem('access_token');
    if (token) {
        try {
            const response = await fetch('http://localhost:8080/protected-resource', {
                method: 'GET',
                headers: {
                    'Authorization': `Bearer ${token}`,
                },
            });

            const data = await response.json();
            console.log('Protected data:', data);
        } catch (error) {
            console.error('Error fetching protected data:', error);
        }
    } else {
        console.log('No access token found');
    }
}

// Custom error code
export const UNAUTHORIZED: number = 1003
export const INTERNAL_SERVER_ERROR: number = 1004
export const DATA_VALIDATION_ERROR: number = 1005
export const ACCESS_TOKEN_INVALID: number = 1006
export const ACCESS_TOKEN_EXPIRED: number = 1007
export const SEQUENCE_GENERATION_ERROR: number = 1008
export const RECODE_ALREADY_EXIST: number = 1009
export const RECODE_NOT_FOUND: number = 1010
export const USER_CREDENTIALS_ERROR: number = 1011
export const ROLE_HAVE_NOT_PERMISSION: number = 1012
export const LOGIN_FAILED: number = 1013

export type ResponseTypes = {
    message: string;
    httpStatus: string;
    data?: any;
    errorCode?: number;
    errorMessage?: number;
    access_token?: string
}

export const APICall = async (url: string, method: string, body?: any): Promise<any> => {
    try {
        const options: RequestInit = {
            method: method,
            headers: { 'Content-Type': 'application/json' },
        };

        if (body) {
            options.body = JSON.stringify(body);
        }

        const response = await fetch(url, options);
        
        if (!response.ok) {
            const errorData = await response.json();
            const error = new Error(errorData.error || 'Request failed') as any;
            error.details = errorData.details;
            error.status = response.status;
            throw error;
        }

        return await response.json();
    } catch (error) {
        console.error('API call error:', error);
        throw error;
    }
};

export const APIGetUserAreas = async (): Promise<{status: boolean, data: string[]}> => {
    const URL: string = `${BASE_URL}/identity_manager/api/v1/getUserAreas`
    const header = {
        method: "GET",
        headers: {
            "Content-Type": "application/json",
            Authorization: `Bearer ${getToken()}`
        }
    }
    
    try 
    {
        const response = await fetch(URL, header)
        const responseData = await response.json() as ResponseTypes
    
        if (!response.ok) 
        {
            // API returned error
            console.log("Request failed")
            return {status: false, data: []}
        }
    
        return {status: true, data: responseData.data as string[]}
    } 
    catch (error: any) 
    {
        return {status: false, data: []}
    }
}